import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Fade } from "react-reveal";
import Accordion from "react-bootstrap/Accordion";
import { Link } from "react-router-dom";
import Skeleton from 'react-loading-skeleton'
import { useTranslation } from 'react-i18next';

const Infrastructure = ({ faqsListing, loading }) => {
  const { t } = useTranslation();

   /**
     * Used for render the UI on home page
     */
  return (
    <>
      <section  dir="ltr" className="Infrastructure_section">
        <div className="gradient_Infrastructure"></div>

        <Container>
          <div className="heading_Common_toall position-relative">
           
              <h2 className="heading_common">
                {t('infra_structre_home')} 

              </h2>
           

            <div className="arrow_yellow">
              <img src="/images/yellowarrow.png" alt="" className="img-fluid" />
            </div>
          </div>

          <div className="two_column_section p-5 mt-5">
            <Row>
              <Col lg="6" md="6" sm="12">
                <div className="infraimg_Left">
                  <img
                    src="/images/infraimg.png"
                    alt=""
                    className="img-fluid"
                  />
                </div>
              </Col>

              <Col lg="6" md="6" sm="12">
                <div className="infraaccordion_right text-start">
                  <Accordion defaultActiveKey="0">

                    {faqsListing.length > 0 && faqsListing.map((obj, index) => (
                      <Accordion.Item eventKey={index} key={index}>
                        
                        <Accordion.Header>{obj.question}</Accordion.Header>
                        <Accordion.Body>
                          {obj.answer.replace( /(<([^>]+)>)/ig, '')}
                        </Accordion.Body>
                      </Accordion.Item>
                    ))}

                  </Accordion>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Infrastructure;
